module.exports = __webpack_public_path__ + "media/images/Logo hortense rel-f7799e8a4c329d419f4ec2938f241c7e.svg";